import { createAction, props } from '@ngrx/store';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';

export const ChangeSelectedSystem = createAction(
  '[Integration Management: Search]: Change Selected System',
  props<{ system: string }>()
);

export const ChangeActiveStatus = createAction(
  '[Integration Management: Search]: Change Active Status',
  props<{ activeStatus: boolean }>()
);

export const ChangeInActiveStatus = createAction(
  '[Integration Management: Search]: Change InActive Status',
  props<{ inActiveStatus: boolean }>()
);

export const ChangeName = createAction(
  '[Integration Management: Search]: Change Name',
  props<{ name: string }>()
);

export const ClearFilters = createAction(
  '[Integration Management: Search]: Clear Filters'
);

export const CreateNew = createAction(
  '[Integration Management: Search]: Create New'
);

export const LoadSearch = createAction(
  '[Integration Management: Search]: Search'
);

export const LoadResultsSuccess = createAction(
  '[Integration Management: Search]: Load Results Success',
  props<{ data: any[] }>()
);

export const LoadResultsFailed = createAction(
  '[Integration Management: Search]: Load Results Failed',
  props<{ error: any }>()
);

export const GetIntegrationTypes = createAction(
  '[Integration Management: Search]: Get Integration Types'
);

export const GetIntegrationTypesSuccess = createAction(
  '[Integration Management: Search]: Get Integration Types Success',
  props<{ response: QcResponse }>()
);

export const GetIntegrationTypesFailed = createAction(
  '[Integration Management: Search]: Get Integration Types Failed',
  props<{ error: any }>()
);

export const PanelStatus = createAction(
  '[Integration Management: Search]: Panel Status Changed'
);

export const CountIntegrationByFilter = createAction(
  '[Integration Management: Search]: Count Integration By Filter'
);

export const CountIntegrationByFilterSuccess = createAction(
  '[Integration Management: Search]: Count Integration By Filter Success',
  props<{ response: QcResponse }>()
);

export const CountIntegrationByFilterFailed = createAction(
  '[Integration Management: Search]: Count Integration By Filter Failed',
  props<{ error: any }>()
);
